import React from 'react';
import { components, type OptionProps } from '@atlaskit/select';
import { SimpleTag } from '@atlaskit/tag';
import { getTagColor } from '@atlassian/jira-servicedesk-customer-service-common';
import type { SelectFieldOptionsType } from '../../../types';

export const OptionView = (props: OptionProps<SelectFieldOptionsType>) => (
	<components.Option {...props}>
		<SimpleTag
			testId="servicedesk-customer-service-custom-details.common.ui.field.select-field.multi.option-view.tag"
			text={props.data.label}
			color={getTagColor(props.data.color)}
		/>
	</components.Option>
);
